import React from 'react';
import PropTypes from 'prop-types';
import { Button, Select, Input } from 'module-tsl-ui-elements';

var SearchZone = function SearchZone(_ref) {
  var searchLink = _ref.searchLink,
      isHome = _ref.isHome,
      firstDropDownOptions = _ref.firstDropDownOptions,
      secondDropDownOptions = _ref.secondDropDownOptions;
  var updateHtmlJs = "document.getElementById('keyword').focus();\n    document.getElementById('searchForm').onsubmit = function () {\n    window._mz.setReferrerData({\n      module:'".concat(isHome ? 'resource-home-search' : 'resource-hub-search', "',\n      pagetype:'").concat(isHome ? 'resource-home' : 'resource-hub', "'\n    });\n    var valueEncoded= encodeURIComponent(document.getElementById('keyword').value);\n    var firstDropDown = document.getElementById('resources-form__item--select1');\n    var secondDropDown = document.getElementById('resources-form__item--select2');\n    var subjectVal = encodeURIComponent(firstDropDown.options[firstDropDown.selectedIndex].value);\n    var yearsVal = encodeURIComponent(secondDropDown.options[secondDropDown.selectedIndex].value);\n    window.location.href = '").concat(searchLink, "' + '&q=' + valueEncoded + '&years=' + yearsVal + '&subjects=' + subjectVal;\n    return false;\n  }");
  return /*#__PURE__*/React.createElement("form", {
    className: "resources-form",
    id: "searchForm",
    method: "get"
  }, /*#__PURE__*/React.createElement("div", {
    className: "resources-form__item tds-control-icon-wrapper tds-control-icon-wrapper--is-right"
  }, /*#__PURE__*/React.createElement(Input, {
    id: "keyword",
    placeholder: "Search resources by keyword",
    icon: /*#__PURE__*/React.createElement("i", {
      className: "resources-form__magnifying-icon icon icon-tds-magnifying-glass icon-blue"
    }),
    iconRight: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "resources-form__item resources-form__item--select"
  }, /*#__PURE__*/React.createElement(Select, {
    id: "resources-form__item--select1",
    options: firstDropDownOptions
  })), /*#__PURE__*/React.createElement("div", {
    className: "l-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "resources-form__item resources-form__item--select resources-form__item--inline"
  }, /*#__PURE__*/React.createElement(Select, {
    id: "resources-form__item--select2",
    options: secondDropDownOptions
  })), /*#__PURE__*/React.createElement(Button, {
    className: "resources-form__btn"
  }, "Search")), /*#__PURE__*/React.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: updateHtmlJs
    }
  }));
};

SearchZone.displayName = "SearchZone";
SearchZone.propTypes = {
  searchLink: PropTypes.string.isRequired,
  isHome: PropTypes.bool,
  firstDropDownOptions: PropTypes.arrayOf(PropTypes.object),
  secondDropDownOptions: PropTypes.arrayOf(PropTypes.object)
};
SearchZone.defaultProps = {
  searchLink: '/resources/search/',
  isHome: false,
  firstDropDownOptions: [],
  secondDropDownOptions: []
};
export default SearchZone;